var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(-247.000000, -879.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(248.000000, 880.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2000A",
    fill: "#E2000A",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "i",
    transform: "translate(5.550781, 3.222656)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06640625,2.14453125 L1.06640625,5.2265625 C1.06640625,5.44010417 1.015625,5.6015625 0.9140625,5.7109375 C0.8125,5.8203125 0.68359375,5.875 0.52734375,5.875 C0.37109375,5.875 0.244140625,5.81901042 0.146484375,5.70703125 C0.048828125,5.59505208 0,5.43489583 0,5.2265625 L0,2.17578125 C0,1.96484375 0.048828125,1.80598958 0.146484375,1.69921875 C0.244140625,1.59244792 0.37109375,1.5390625 0.52734375,1.5390625 C0.68359375,1.5390625 0.8125,1.59244792 0.9140625,1.69921875 C1.015625,1.80598958 1.06640625,1.95442708 1.06640625,2.14453125 Z M0.5390625,1.04296875 C0.390625,1.04296875 0.263671875,0.997395833 0.158203125,0.90625 C0.052734375,0.815104167 0,0.686197917 0,0.51953125 C0,0.368489583 0.0540364583,0.244140625 0.162109375,0.146484375 C0.270182292,0.048828125 0.395833333,0 0.5390625,0 C0.677083333,0 0.799479167,0.0442708333 0.90625,0.1328125 C1.01302083,0.221354167 1.06640625,0.350260417 1.06640625,0.51953125 C1.06640625,0.68359375 1.01432292,0.811848958 0.91015625,0.904296875 C0.805989583,0.996744792 0.682291667,1.04296875 0.5390625,1.04296875 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.11520ec9dc8da975752b20802426a4f2.svg";
export { ForwardRef as ReactComponent };